export default __webpack_public_path__ + "static/media/rating.0516e7d2.png";